import React from 'react';

import Purchase from 'billing/purchases/Purchase';
import history_icon from 'common/img/history_icon.svg';

export const PurchaseScreen = ({ id }) => {
  return (
    <div className="Purchase">
      <h1>
        Completed Purchase
        <img src={history_icon} alt="" />
      </h1>
      <Purchase id={id} />
    </div>
  );
}

export default PurchaseScreen;
